// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"03664a7e1d04df9deadf","5179":"10d3c173e43d1cdcbb7b"}[chunkId] + ".css";
};